<template>
    <svg t="1610013595119" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3193" :width="size"
        :height="size">
        <path d="M512 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z" fill="#FB5549" p-id="3194"></path>
        <path
            d="M464 336a48 48 0 1 0 96 0 48 48 0 0 0-96 0zM536 448h-48a8 8 0 0 0-8 8v272c0 4.416 3.584 8 8 8h48a8 8 0 0 0 8-8v-272A8 8 0 0 0 536 448z"
            fill="#ffffff"
            p-id="3195"
        ></path>
    </svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: "10vw",
        },
    },
};
</script>

<style lang="scss" scoped></style>
